import {
  GET_REFUND_POLICY,
  GET_REFUND_POLICY_SUCCESS,
  GET_REFUND_POLICY_ERROR,
  POST_REFUND_POLICY,
  POST_REFUND_POLICY_SUCCESS,
  POST_REFUND_POLICY_ERROR,
  GET_LATEST_REFUND_POLICY,
  GET_LATEST_REFUND_POLICY_SUCCESS,
  GET_LATEST_REFUND_POLICY_ERROR,
} from "./actionTypes"


// For Get insurance_carriers
export const getRefundPolicy = () => ({
  type: GET_REFUND_POLICY,
})

export const getRefundPolicySuccess = (response) => ({
  type: GET_REFUND_POLICY_SUCCESS,
  payload: response
})

export const getRefundPolicyError = (error) => ({
  type: GET_REFUND_POLICY_ERROR,
  payload: error
})

// For Post insurance_carriers

export const postRefundPolicy = (data) => ({
  type: POST_REFUND_POLICY,
  payload: data
})

export const postRefundPolicySuccess = (response) => ({
  type: POST_REFUND_POLICY_SUCCESS,
  payload: response
})

export const postRefundPolicyError = (error) => ({
  type: POST_REFUND_POLICY_ERROR,
  payload: error
})

// For Get latest refund-policy

export const getLatestRefundPolicy = () => ({
  type: GET_LATEST_REFUND_POLICY,
})

export const getLatestRefundPolicySuccess = (response) => ({
  type: GET_LATEST_REFUND_POLICY_SUCCESS,
  payload: response
})

export const getLatestRefundPolicyError = (error) => ({
  type: GET_LATEST_REFUND_POLICY_ERROR,
  payload: error
})
